import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

// Tells the operator when a newer admin has been deployed than the one this tab
// is running. A tab left open for days kept old code — a contact "removed" by
// it never reached the database (2026-10-29). Compares the hashed main-*.js
// this tab loaded with the one /index.html points to now.
@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  private loaded = this.mainBundle(document.documentElement.innerHTML);
  private notified = false;

  constructor(private snackBar: MatSnackBar, private zone: NgZone) { }

  start() {
    if (!this.loaded) return;   // dev build: no hashed bundle names
    this.zone.runOutsideAngular(() => {
      setInterval(() => this.check(), 5 * 60 * 1000);
      window.addEventListener('focus', () => this.check());
    });
  }

  private async check() {
    if (this.notified) return;
    try {
      const html = await (await fetch('/index.html', { cache: 'no-store' })).text();
      const live = this.mainBundle(html);
      if (!live || live === this.loaded) return;
      this.notified = true;
      this.zone.run(() => this.snackBar
        .open('A new version of the admin is available.', 'Reload', { panelClass: 'version-snack' })
        .onAction().subscribe(() => location.reload()));
    } catch { /* offline — try again later */ }
  }

  private mainBundle(html: string): string | null {
    const m = /main-[A-Z0-9]+\.js/.exec(html);
    return m ? m[0] : null;
  }
}
